import React from 'react'
import PropTypes from 'prop-types'
import { checkEnableButton, i18nTranslate } from 'src/utils'
import { Link } from 'react-router-dom'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  Card,
  Row,
  Button,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from 'react-bootstrap'
import {
  isMerchPLP,
  enableQuickView,
  enableProductCompare,
  APPConfig,
  IS_BROWSER,
} from 'config/appConfig'
import { AiOutlineShoppingCart as CartIconNew } from 'react-icons/ai'
import { IoMdCheckmark } from 'react-icons/io'
import { catalogDeps, productDeps, searchDeps } from 'src/deps'
import { pageNames } from 'src/routes/pathParams'
import {
  quickViewState,
  ProductBadge,
  ProductPromotion,
  ProductFavorites,
  CustomPrice,
  ImageComponent,
  toastState,
} from 'src/views/components'
import { NsSpinner } from '@nuskin/foundation-ui-components'
import {
  application,
  checkIsMobile,
  getImageFromProperty,
  trackProductClick,
  trackProductClickEvent,
  getLocalStorage,
  setLocalStorage,
  getLiveEventStatus,
  getWebAvailableChannel,
  convertToBoolean,
  shouldDisableLiveEventCartAction,
  isEligibleToShowPVCVSV,
  enablePlpRedesign,
  trackRedesignProductClickEvent,
  trackRedesignAddToCartEvent,
  trackPathToPurchaseSelectItem,
  enableNewFeature,
  isPOAdminScreen,
  getFavoritesEnabled,
} from 'src/utils'
import { renderPrysmBadgeContent } from 'src/views/components/Common/PrysmBadge'
import { ProductCompare } from '../ProductCompare'
import { MerchAlternateImages } from '../MerchAlternateImages'
import colorCode from 'src/static/fixtures/colorCode.json'
import { catalogState } from 'src/models/Catalog/catalogState'
import { specialProductTypes } from '../fixture'
import {
  cartContainer,
  customerContainer,
  catalogContainer,
  accountsContainer,
  mysiteContainer,
} from 'src/models'
import TagManager from 'react-gtm-module'
import { productState } from '../../../components/BaseProductComponent/ProductState'
import { ProductCardPrice } from 'src/views/components/Price'
import { NuskinPlusCartIcon } from 'src/views/components/Header/Components/CartIcon/NuskinCartIcon'
import { NuskinTaskIcon } from 'src/views/components/Header/Components/CartIcon/NuskinTaskIcon'
import NotifyDirectSellerPopup from '../../ProductComponents/NotifyDirectSellerPopup/NotifyDirectSellerPopup'
import ProductStatusBadge, { getProductStatuses } from './ProductStatusBadge'
import {
  shouldRedirectToPdp,
  shouldRedirectBasedOnProduct,
  isSkuDisabledForSelection,
} from './ProductCardUtils'
import { builder } from 'src/models/Catalog/builder'
import debounce from 'lodash/debounce'
import { PlpBundleOrKitSelectOptions } from '../PlpBundleOrKitSelectOptions'
import { dropdownIcon } from '../PlpBundleOrKitSelectOptions/fixture'
import {
  extractCarouselImages,
  getSelectedImageUrlForMysitePLP,
} from './productImageCarouselUtils'
import ProductImageCarousel from './ProductImageCarousel'
import './ProductImageCarousel.scss'
import './styles.scss'
import { isEquinoxMysite } from 'src/utils/mySiteUtils'

@observer
class ProductCard extends React.Component {
  nameSpace = 'ssr-resource'
  @observable imageArrayProperties = { images: [], currentIndex: 0 }
  @observable selectedVariantValue = {}
  @observable bundlePdpResponse = {}
  @observable bundlePromotionResponse = {}
  @observable showSelectOptionsModal = false
  @observable selectedProductId = null
  @observable isFetchingOptions = false
  @observable disableNormalMultiVariantAddBtn = false
  @observable isPlpRedesignEnabled =
    enablePlpRedesign() && !this.props?.isFavorite
  isSubscriptionOnly = false
  productCard = ''
  currentRef = React.createRef()
  selectOptionDropdownRef = React.createRef()
  enableLiveEvent = getLiveEventStatus()

  constructor(props) {
    super(props)
    if (isMerchPLP) {
      this.imageArrayProperties.images = catalogState.getImageArray(
        props?.product
      )
    }
    // Restore the previously fetched bundle promotion price so it survives remounts (e.g. pagination)
    if (Object.keys(props?.previouslySelectedBundleTotalValue || {}).length > 0) {
      this.bundlePromotionResponse = { totalValue: props.previouslySelectedBundleTotalValue }
    }
    this.state = {
      windowWidth: typeof window === 'object' ? window.innerWidth : 0,
      localIsSelected: props.isSelected || false, // Local checkbox state for instant updates
      isSelectedVariantDisabled: false, // Tracks if selected variant should disable checkbox (POAdmin only)
    }
  }

  componentDidUpdate(prevProps) {
    // Sync local checkbox state when parent changes (e.g., "Clear All" or external updates)
    if (prevProps.isSelected !== this.props.isSelected) {
      this.setState({ localIsSelected: this.props.isSelected })
    }

    if (
      (prevProps.isCheckboxDisabled !== this.props.isCheckboxDisabled ||
        prevProps.isSelected !== this.props.isSelected) &&
      this.props.isCheckboxDisabled &&
      !this.props.isSelected &&
      this.state.localIsSelected
    ) {
      this.setState({ localIsSelected: false })
    }

    // Reset variant selection when product changes (prevents SKU mismatch on component reuse)
    if (prevProps.product?.identifier !== this.props.product?.identifier) {
      this.selectedVariantValue = {}
      this.bundlePdpResponse = {}
      // Restore the previously fetched bundle promotion price so it survives remounts (e.g. pagination)
      this.bundlePromotionResponse =
        Object.keys(this.props?.previouslySelectedBundleTotalValue || {}).length > 0
          ? { totalValue: this.props.previouslySelectedBundleTotalValue }
          : {}
      this.disableNormalMultiVariantAddBtn = false

      this.setState({
        localIsSelected: this.props.isSelected || false,
        isSelectedVariantDisabled: false,
      })

      // Initialize from props if product was previously selected with a variant (POAdmin only)
      this.initializeSelectedVariantFromProps()
    }

    // Also initialize when selectedVariantSkuId prop changes (e.g., pagination/filter)
    if (prevProps.selectedVariantSkuId !== this.props.selectedVariantSkuId) {
      this.initializeSelectedVariantFromProps()
    }
  }

  initializeSelectedVariantFromProps = async () => {
    if (!isPOAdminScreen()) return

    const { selectedVariantSkuId, selectedVariantLabel, isSelected } =
      this.props

    // Only initialize if product is selected and variant was previously chosen
    if (
      isSelected &&
      selectedVariantSkuId &&
      !this.selectedVariantValue?.selectedSku
    ) {
      this.selectedVariantValue['selectedSku'] = selectedVariantSkuId
      this.selectedVariantValue['selectedVariant'] = selectedVariantLabel || ''

      // Fetch promotion/price data for the selected variant
      // Always use product identifier for API calls, not the productId prop (which may be SKU ID in POAdmin)
      const productIdentifier = this.props?.product?.identifier || ''
      const categoryId = this.props?.product?.categoryId || ''
      const productType = this.props?.product?.type || 'DEFAULT'
      const productObject = {
        productId: productIdentifier,
        categoryId: categoryId,
        type: productType,
        quantity: 1,
        skuId: selectedVariantSkuId,
      }

      try {
        this.disableNormalMultiVariantAddBtn = true
        const response =
          await cartContainer.makePromotionCallsForNormalProduct(productObject)
        if (!cartContainer.isSuccessResponse(response)) {
          this.selectedVariantValue[selectedVariantSkuId] =
            catalogDeps.getDefaultSelectedSku(this.props?.product)?.[0]
              ?.totalValue || {}
          this.selectedVariantValue[selectedVariantSkuId].promotionAPIError =
            true
        } else {
          this.selectedVariantValue[selectedVariantSkuId] = response || {}
        }
      } catch (error) {
        console.warn('Failed to fetch promotion for selected variant:', error)
      } finally {
        this.disableNormalMultiVariantAddBtn = false
      }
    }
  }

  handleCurrentImage = () => {
    const index = catalogState.handleCurrentImage(this.imageArrayProperties)
    this.imageArrayProperties.currentIndex = index
  }

  handleQuickView = (e, idToFocus, replacementProductStatus = false) => {
    const handleFocus = () => {
      if (this.currentRef && e.code === 'Enter') {
        setTimeout(
          () => this.currentRef.current.focus({ focusVisible: true }),
          500
        )
      }
    }
    e.preventDefault()
    e.stopPropagation()

    const productId =
      this.props?.product?.properties?.slug ||
      this.props?.productId ||
      this.props?.product?.identifier ||
      ''

    const categoryId = this.props?.categoryId || ''
    const defaultSku = catalogDeps.getDefaultSelectedSku(this.props.product)
    const skuSlug = defaultSku?.[0]?.properties?.slug || ''
    const skuId = defaultSku?.[0]?.identifier || ''
    const hasMoreThanOneSku = (this.props.product?.sku?.length || 1) > 1
    const variantParameter = skuSlug || skuId || ''
    const isMultiVariant = defaultSku?.[0]?.properties?.variantLabel || ''
    /* @variant_autoselect */
    quickViewState.getProduct({
      productId,
      categoryId,
      handleFocus,
      defaultVariantForQuickView: variantParameter,
      isMultiVariant: isMultiVariant,
    })
    catalogContainer.isQuickview = true
    TagManager.dataLayer({
      dataLayer: {
        event: 'quickView',
        pagePath: '/catalog/' + categoryId,
        pageTitle: 'Product Detail',
        item_name: this.props?.product?.properties?.name || '',
        item_type: replacementProductStatus ? 'discontinued' : '',
        item_view: 'PLP quickview',
        item_id: skuId,
        quikeProductId: productId,
        platform: 'equinox',
      },
    })
  }

  renderProductCompare = () => {
    const { categoryId = '', productId = '' } = this.props || {}
    const { imageURL = '' } = this.props?.product?.properties || {}
    return (
      <ProductCompare
        productId={productId}
        categoryId={categoryId}
        imageURL={imageURL}
      />
    )
  }

  addToCart = async (productId = '', skuId = '', productCount = 0) => {
    const cartArray = [
      {
        productId: productId,
        quantity: productCount,
        skuId: skuId,
      },
    ]
    if (cartArray) {
      const response = await cartContainer.addToCart({
        cartArray,
      })
      return response
    }
  }

  getPdtImage = () => {
    const { product } = this.props || {}
    if (isMerchPLP) {
      const { currentIndex, images } = this.imageArrayProperties
      return images[currentIndex]
    } else if (product?.type == 'kit' || product?.type === 'bundle') {
      return getImageFromProperty(product?.properties)
    }
    const isVariantSelected =
      this.isPlpRedesignEnabled && this.selectedVariantValue?.selectedSku
    const defaultSku = isVariantSelected
      ? catalogDeps.getSelectedSkuById(
          product,
          this.selectedVariantValue?.selectedSku
        )
      : catalogDeps.getDefaultSelectedSku(product)
    return getImageFromProperty(defaultSku?.[0]?.properties)
  }

  handleQuantityChange = count => {
    productState.productCount = count || 0
    this.quantity = count || 0
    if (this.props?.onSubscriptionQuantityChange) {
      this.props?.onSubscriptionQuantityChange(count)
    }
  }

  handleProductClick = () => {
    const product = this.props.product
    const isSpecialProduct = specialProductTypes.includes(product?.type)
    const isVariantSelected = this.selectedVariantValue?.selectedSku
    const selectedMultiVarSkuPrice =
      this.selectedVariantValue?.[this.selectedVariantValue?.selectedSku] || ''

    const defaultSku = isVariantSelected
      ? catalogDeps.getSelectedSkuById(
          product,
          this.selectedVariantValue?.selectedSku
        )
      : catalogDeps.getDefaultSelectedSku(product)
    const resolvedProduct =
      defaultSku && defaultSku.length > 0 ? defaultSku[0] : product
    const sponsorId =
      typeof accountsContainer?.getUserTypeSponsorId === 'function'
        ? accountsContainer.getUserTypeSponsorId()
        : undefined
    const rawIndex =
      this.props?.index ?? this.props?.productIndex ?? this.props?.position ?? 0
    const itemListName =
      this.props?.itemListName ||
      this.props?.categoryName ||
      this.props?.categoryId ||
      'all products'
    if (enableNewFeature('enableGTMSelectItemEvent')) {
      trackPathToPurchaseSelectItem({
        product: resolvedProduct,
        baseProduct: product,
        itemListName,
        itemIndex: rawIndex,
        sponsorId,
        categoryName: this.props?.categoryId,
        selectedMultiVarSkuPrice:
          selectedMultiVarSkuPrice?.totalValue?.priceAfterDiscount,
      })
    } else {
      trackProductClick({
        type: 'productClick',
        action: { list: 'Search Results' },
        isSpecialProduct,
        categoryId: this.props?.categoryId,
        product,
      })
    }

    if (this.enableLiveEvent === 'true') {
      trackProductClickEvent({
        type: 'select_item',
        action: { list: 'Search Results' },
        isSpecialProduct,
        categoryId: this.props?.categoryId,
        product,
        promotion: false,
      })

      // select_promotion event is disabled as July Live Event is not having promotions
      // if (this.props?.product?.promotion?.length > 0) {
      //   trackProductClickEvent({
      //     type: 'select_promotion',
      //     action: { list: 'Search Results' },
      //     isSpecialProduct,
      //     categoryId: this.props?.categoryId,
      //     product,
      //     promotionClass: this.props?.product?.promotion?.[0]?.promotionClass,
      //     offerId: this.props?.product?.promotion?.[0]?.offerId,
      //     promotion: true,
      //   })
      // }
    }
  }

  handleAddClick = async () => {
    setLocalStorage('isExpressCart', false)
    const productId =
      this.props?.product?.identifier || this.props?.productId || ''

    cartContainer.addToCartClickedProductDetails = this.props?.product
    const rowIndex =
      this.props?.index ?? this.props?.productIndex ?? this.props?.position ?? 0

    if (this.props?.product?.type === 'kit') {
      return searchDeps.handleAddtoCart(
        this.props?.product,
        false,
        true,
        this.props?.isFromCatalog || false,
        this.isSubscriptionOnly,
        rowIndex
      )
    } else {
      const isPbomProduct = productDeps.isPbomProduct(this.props?.product)
      const isVariantSelected =
        this.isPlpRedesignEnabled && this.selectedVariantValue?.selectedSku
      const defaultSku = isVariantSelected
        ? catalogDeps.getSelectedSkuById(
            this.props.product,
            this.selectedVariantValue?.selectedSku
          )
        : catalogDeps.getDefaultSelectedSku(this.props.product)
      const skuSlug =
        this.props?.product?.properties?.slug ||
        defaultSku?.[0]?.properties?.slug ||
        ''
      const scanQualifiedCount =
        this.props?.product?.properties?.scanQualifiedCount || ''
      const skuId = defaultSku?.[0]?.identifier || ''
      const isBackOrdered =
        defaultSku?.[0]?.inventoryProperties?.backOrdered || ''

      if (this.isSubscriptionOnly) {
        const isToShowViewCartButton = true
        let source = 'plp-product-card'
        const postData = {
          quantity: 1,
          skus: [
            {
              skuId: skuId || '',
              productId: productId || '',
              type: 'DEFAULT',
            },
          ],
          isSubscription: true,
          subscription: {
            frequencyPeriod: '1',
            frequencyType: 'MONTHS',
            type: 'VARIABLE_MULTI_ORDER',
          },
          properties: {
            category: catalogContainer?.categoryListName?.plp?.categoryId || '',
            categoryId:
              catalogContainer?.categoryListName?.plp?.categoryId || '',
            listName: catalogContainer?.categoryListName?.plp?.listName || '',
            slug: skuSlug || '',
            scanQualifiedCount: scanQualifiedCount,
          },
          orderProcessedDate: '',
          month: '',
        }
        return await cartContainer.addToCartFromViewCart(
          [postData],
          source,
          isToShowViewCartButton,
          false,
          true,
          this.props?.isFromCatalog || false,
          rowIndex
        )
      }
      return await cartContainer.addToCart({
        cartArray: [
          {
            productId: productId,
            quantity: 1,
            skuId: skuId,
            slug: skuSlug,
            isBackOrdered: isBackOrdered,
            isPbomProduct: isPbomProduct,
            categoryId:
              catalogContainer?.categoryListName?.plp?.categoryId || '',
            listName: catalogContainer?.categoryListName?.plp?.listName || '',
          },
        ],
        isFromPLP: this.props?.isFromCatalog || false,
        itemIndex: rowIndex,
      })
    }
  }

  handleProductCart = async (options = {}) => {
    const { product, url } = options

    try {
      const isRedirectToPdp = await shouldRedirectToPdp(product?.identifier)
      if (isRedirectToPdp && url) {
        this.props.history.push(url)
      } else {
        searchDeps.handleAddtoCart(product)
      }
    } catch (error) {
      console.error('Error fetching product:', error)
    }
  }

  handleSelectOptionsClick = async identifier => {
    const isProductResponseCached = !!this.bundlePdpResponse?.product?.[0]
    try {
      const allPlpCardItems = document.querySelectorAll(
        '.plp-card-item.selectOptionClicked'
      )
      allPlpCardItems.forEach(item => {
        item.classList.remove('selectOptionClicked')
      })

      if (!isProductResponseCached) {
        this.isFetchingOptions = true
      }

      const productResponse = isProductResponseCached
        ? this.bundlePdpResponse
        : await catalogContainer.getProduct({
            productId: identifier,
          })

      if (productResponse?.product?.[0]) {
        this.bundlePdpResponse = productResponse
        const currentPlpCardItem = document.querySelectorAll(
          `.product_card_${identifier}`
        )
        currentPlpCardItem.forEach(item => {
          item.classList.add('selectOptionClicked')
        })

        if (application?.isMobile) {
          document.body.style.overflow = 'hidden'
        }
      } else {
        const loadErrorMessage = i18nTranslate(
          'product.failedToLoadData',
          'Failed to load product data'
        )
        toastState.setToastMessage(loadErrorMessage, false)
      }
    } catch (error) {
      const generalErrorMessage = i18nTranslate(
        'signup.accountCreationFailure',
        'Something went wrong'
      )
      toastState.setToastMessage(generalErrorMessage, false)
    } finally {
      this.isFetchingOptions = false
    }
  }

  handleCancelSelectOptionsClick = () => {
    const allPlpCardItems = document.querySelectorAll(
      '.plp-card-item.selectOptionClicked'
    )
    allPlpCardItems.forEach(item => {
      item.classList.remove('selectOptionClicked')
    })

    if (application?.isMobile) {
      document.body.style.overflow = ''
    }
  }

  publishBundleSelection = (productId, selectedVariants) => {
    if (!this.props?.onSelectionChange) return
    const productWithVariants = {
      ...this.props.product,
      selectedBundleVariants: selectedVariants,
    }
    if (Object.keys(this.bundlePromotionResponse?.totalValue || {}).length > 0) {
      productWithVariants.totalValue = this.bundlePromotionResponse.totalValue
    }
    this.props.onSelectionChange(productId, true, productWithVariants)
  }

  handleBundleSelection = bundleData => {
    const { productId, selectedVariants } = bundleData || {}
    if (!productId) return

    // Close the select options modal
    this.handleCancelSelectOptionsClick()

    // Update local checkbox state IMMEDIATELY for bundles
    this.setState({ localIsSelected: true })

    // Trigger selection with variant data
    this.publishBundleSelection(productId, selectedVariants)
  }

  makePromotionCallForBundleProducts = async bundleData => {
    const { productId, selectedVariants } = bundleData || {}
    if (!productId) return

    const categoryId = this.props?.product?.categoryId || ''
    const bundleSelectionPayload = {
      productId,
      categoryId,
      quantity: bundleData?.quantity || '1',
      isSubscriptionIncludedInPromotion: true,
      isSubscriptionPromotion: true,
      skus:
        Array.isArray(selectedVariants) && selectedVariants.length
          ? selectedVariants.map(variant => ({
              productId: variant?.productId || '',
              skuId: variant?.skuId || '',
              skuQuantity: variant?.quantity || '1',
            }))
          : [],
    }

    try {
      const promotionResponse =
        await cartContainer.makePromotionCall({
          ...bundleSelectionPayload,
          isCallMadeFromNewDesignPDP: true,
          type: 'bundle'
        })

      this.bundlePromotionResponse = promotionResponse || {}

      // Re-publish only on success, so a stale/aborted call never overwrites
      // a newer selection's already-published totalValue.
      if (this.state.localIsSelected && this.props?.onSelectionChange) {
        this.publishBundleSelection(productId, selectedVariants)
      }
    } catch (error) {
      console.warn('Failed to fetch promotion for selected bundle variants:', error)
      this.bundlePromotionResponse = {}
    }
  }

  handleKitSelection = async () => {
    if (!isPOAdminScreen()) return null

    const productId = this.props?.product?.identifier
    if (!productId) return null

    try {
      // Fetch kit product details to get skuKit subItems
      const response = await catalogContainer.getProduct({
        productId: productId,
        suppressProductEvent: true,
      })

      const kitProduct = response?.product?.[0] || {}
      const skuKit = kitProduct?.skuKit || []

      if (skuKit.length > 0) {
        // Build kit subItems array similar to bundle variants
        const kitSubItems = skuKit.map(subItem => {
          const defaultSku =
            catalogDeps.getDefaultSelectedSku(subItem)?.[0] ||
            subItem?.sku?.[0] ||
            {}
          return {
            productId: subItem?.identifier || '',
            skuId: defaultSku?.identifier || '',
            quantity: subItem?.properties?.quantity || 1,
            availableChannels: defaultSku?.properties?.availableChannels || '',
            name:
              defaultSku?.properties?.name || subItem?.properties?.name || '',
          }
        })

        return kitSubItems
      }
    } catch (error) {
      console.error('Error fetching kit product details:', error)
    }

    return null
  }

  handleSelectOptionChange = async item => {
    // Always use product identifier for API calls, not the productId prop (which may be SKU ID in POAdmin)
    const productIdentifier = this.props?.product?.identifier || ''
    const categoryId = this.props?.product?.categoryId || ''
    const productType = this.props?.product?.type || 'DEFAULT'
    const selectedSkuId = item?.identifier
    const productObject = {
      productId: productIdentifier,
      categoryId: categoryId,
      type: productType,
      quantity: 1,
      skuId: selectedSkuId,
    }
    this.disableNormalMultiVariantAddBtn = true
    this.selectedVariantValue['selectedSku'] = selectedSkuId
    this.selectedVariantValue['selectedVariant'] = item?.label || ''

    // For POAdmin: Always update disabled state when variant changes
    if (isPOAdminScreen() && this.props?.onSelectionChange) {
      const selectedSku = catalogDeps.getSelectedSkuById(
        this.props.product,
        selectedSkuId
      )
      const isVariantDisabled = isSkuDisabledForSelection(selectedSku?.[0])
      this.setState({ isSelectedVariantDisabled: isVariantDisabled })

      // If product is currently selected, handle selection changes
      if (this.state.localIsSelected) {
        const productWithUpdatedVariant = {
          ...this.props.product,
          selectedVariantSkuId: selectedSkuId,
          selectedVariantLabel: item?.label || '',
          selectedSkuData: selectedSku?.[0] || null,
        }
        
        const selectionContext = {
          isVariantChange: true,
          defaultSkuId: this.props.defaultSkuId || this.props.productId, // Card's original default SKU
        }
        
        if (isVariantDisabled) {
          // Switching to disabled variant: uncheck and remove from selection
          this.setState({ localIsSelected: false })
          // Pass product identifier so parent can find and remove by product identifier
          this.props.onSelectionChange(this.props.product?.identifier, false, productWithUpdatedVariant, selectionContext)
        } else {
          // Switching to enabled variant: keep selected, just update variant data
          this.props.onSelectionChange(selectedSkuId, true, productWithUpdatedVariant, selectionContext)
        }
      }
    }
    if (
      !Object.keys(this.selectedVariantValue || [])?.includes(selectedSkuId) ||
      this.selectedVariantValue[selectedSkuId]?.promotionAPIError
    ) {
      const response =
        await cartContainer.makePromotionCallsForNormalProduct(productObject)
      if (!cartContainer.isSuccessResponse(response)) {
        this.selectedVariantValue[selectedSkuId] =
          catalogDeps.getDefaultSelectedSku(this.props?.product)?.[0]
            ?.totalValue || {}
        this.selectedVariantValue[selectedSkuId].promotionAPIError = true
      } else {
        this.selectedVariantValue[selectedSkuId] = response || {}
      }
    }
    this.disableNormalMultiVariantAddBtn = false

    if (enableNewFeature('enableGTMSelectItemEvent')) {
      const sponsorId =
        typeof accountsContainer?.getUserTypeSponsorId === 'function'
          ? accountsContainer.getUserTypeSponsorId()
          : ''
      const rawIndex =
        this.props?.index ??
        this.props?.productIndex ??
        this.props?.position ??
        0
      const itemListName =
        this.props?.itemListName ||
        this.props?.categoryName ||
        this.props?.categoryId ||
        'all products'

      const selectedSkuArray = catalogDeps.getSelectedSkuById(
        this.props?.product,
        selectedSkuId
      )
      const selectedSkuObject =
        selectedSkuArray && selectedSkuArray.length > 0
          ? selectedSkuArray[0]
          : {}

      trackPathToPurchaseSelectItem({
        product: selectedSkuObject,
        baseProduct: this.props?.product,
        itemListName: itemListName,
        itemIndex: rawIndex,
        sponsorId,
        categoryName: this.props?.categoryName || this.props?.categoryId || '',
        selectedVariantLabel: item?.label || '',
      })
    }
    this.setState({ isDropdownOpen: false })

    // Restore focus to the dropdown button instead of blurring to keep
    // focus on the "Select your option" field for keyboard accessibility (NGE1-5039)
    setTimeout(() => {
      if (this.selectOptionDropdownRef.current) {
        this.selectOptionDropdownRef.current.focus()
      }
    }, 100)
  }

  // Close the variant dropdown on mouse-leave. During mixed mouse/keyboard use,
  // focus can still be inside the menu; restore it to the toggle so it never
  // lands on hidden menu content (NGE1-5039).
  closeDropdownOnMouseLeave = () => {
    this.setState({ isDropdownOpen: false })
    const toggleNode = this.selectOptionDropdownRef.current
    const activeElement = IS_BROWSER ? document.activeElement : null
    if (
      toggleNode &&
      activeElement &&
      activeElement !== toggleNode &&
      activeElement.closest?.('.pdp-select-option-dropdown')
    ) {
      toggleNode.focus()
    }
  }

  renderSelectOptions = (
    variantTypeValues,
    defaultVariantId,
    defaultVariantLabel
  ) => {
    const showVariantDropdown =
      Array.isArray(variantTypeValues) && variantTypeValues?.length > 0
    const selectedVariant = this.selectedVariantValue?.selectedSku
      ? this.selectedVariantValue?.selectedSku
      : defaultVariantId
    const items = showVariantDropdown ? (
      variantTypeValues?.map(item => {
        const isSelectedClass =
          item.identifier === selectedVariant ? 'selected' : ''
        return (
          <Dropdown.Item
            role="button"
            aria-label={item?.label}
            key={item?.label}
            value={item?.identifier}
            className={isSelectedClass}
            onClick={debounce(event => {
              this.handleSelectOptionChange(item)
            }, 700)}
            onKeyPress={debounce(event => {
              this.handleSelectOptionChange(item)
            }, 700)}
            data-testid="qa-pdp-select-option-label">
            {item.label}
          </Dropdown.Item>
        )
      })
    ) : (
      <></>
    )
    if (!showVariantDropdown) {
      return <></>
    }

    const { isDropdownOpen } = this.state
    const isTouchDevice =
      IS_BROWSER && ('ontouchstart' in window || navigator.maxTouchPoints > 0)

    return (
      <div
        className="pdp-select-option"
        {...(!isTouchDevice && {
          onMouseLeave: this.closeDropdownOnMouseLeave,
        })}>
        <span className="pdp-select-option-dropdown-title">
          {i18nTranslate('product.selectOption', 'Select your option', {
            nameSpace: 'ssr-resource',
          }) + ': '}
        </span>
        <Dropdown
          className="pdp-select-option-dropdown"
          data-testid="qa-pdp-select-option-dropdown"
          drop="up"
          show={isDropdownOpen}
          onToggle={open => this.setState({ isDropdownOpen: open })}>
          <Dropdown.Toggle
            ref={this.selectOptionDropdownRef}
            className="d-flex pdp-select-option-dropdown-toggle text-left"
            variant="light"
            onClick={() => this.setState({ isDropdownOpen: !isDropdownOpen })}
            onBlur={() => {
              setTimeout(() => {
                if (
                  !document.activeElement ||
                  !document.activeElement.closest('.pdp-select-option')
                ) {
                  this.setState({ isDropdownOpen: false })
                }
              }, 150)
            }}>
            <div className="pdp-select-option-dropdown-left-section">
              <span
                className="pdp-select-option-dropdown-value"
                data-testid="qa-pdp-select-option-value">
                {this.selectedVariantValue?.selectedVariant ||
                  defaultVariantLabel}
              </span>
            </div>
            <div className="dropdown-right-section">{dropdownIcon()}</div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="pdp-select-option-dropdownmenu">
            {items}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }

  componentDidMount() {
    if (typeof window === 'object') {
      this._resizeHandler = () => {
        this.setState({ windowWidth: window.innerWidth })
      }
      window.addEventListener('resize', this._resizeHandler)
    }

    // Initialize variant selection from props on mount (for POAdmin previously selected variants)
    this.initializeSelectedVariantFromProps()
  }

  componentWillUnmount() {
    if (this._resizeHandler && typeof window === 'object') {
      window.removeEventListener('resize', this._resizeHandler)
    }
  }

  checkIsRange = totalValue => {
    const { priceFacets = {} } = totalValue || {}
    const isPVCVRange =
      totalValue &&
      priceFacets &&
      ((priceFacets.PV && priceFacets.PV?.PVDiscount) ||
        (priceFacets.CV && priceFacets.CV?.CVDiscount))
        ? true
        : false

    const isPriceRange = totalValue && totalValue?.totaldiscount ? true : false
    return isPVCVRange || isPriceRange ? true : false
  }

  render() {
    const {
      productBadge = '',
      showLazyLoad = true,
      categoryId = '',
      productPromotion = [],
      productType = '',
      isProductComparable = false,
      productId = '',
      template6 = false,
      product = {},
      isFavorite = false,
      index = '0',
      isFromCatalog = false,
      selectedCategories = [],
    } = this.props || {}
    const enableDirectSellerButton =
      APPConfig?.getAppConfig()?.enableDirectSellerButton == 'true' &&
      (typeof productDeps?.isDirectSellerProduct === 'function'
        ? productDeps.isDirectSellerProduct(this.props?.product)
        : false)
    const { totalValue = {} } = product
    const { priceFacets = {} } = totalValue
    const userCountry = customerContainer.getUsersCountry()
    const localvalue = getLocalStorage('accountType')
    const isBundle = product?.type === 'bundle'
    const isKit = product?.type == 'kit'
    const isVariantSelected =
      this.isPlpRedesignEnabled && this.selectedVariantValue?.selectedSku
    const defaultSku = isVariantSelected
      ? catalogDeps.getSelectedSkuById(
          product,
          this.selectedVariantValue?.selectedSku
        )
      : catalogDeps.getDefaultSelectedSku(product)
    const skuName =
      defaultSku && defaultSku.length
        ? defaultSku[0]?.properties?.name || ''
        : ''

    const { brand, imageURL: image = '' } =
      this.props?.product?.properties || {}

    const name = isVariantSelected
      ? skuName
      : this.isPlpRedesignEnabled && !isBundle && !isKit
        ? defaultSku?.[0]?.properties?.name
        : this.props?.product?.properties?.name || ''

    let CVPrice = product?.priceFacets?.CV || 0
    let PVPrice =
      product?.totalValue?.priceFacets?.PV?.PVAfterDiscount ??
      product?.totalValue?.priceFacets?.PV?.PV ??
      0
    let imageURL
    imageURL = this.getPdtImage()
    if (isEquinoxMysite()) {
      const mysiteImageUrl = getSelectedImageUrlForMysitePLP(
        selectedCategories,
        product,
        defaultSku?.[0]?.identifier
      )
      if (mysiteImageUrl) {
        imageURL = mysiteImageUrl
      }
    }
    const identifier =
      this.props?.productId || this.props?.product?.identifier || ''
    const skuPrice = this.props?.product?.prices || ''
    const productOrSKUPrice = this.props?.product?.transactionPrice || skuPrice
    const productStatuses = getProductStatuses(this.props?.product, defaultSku)
    let productStatusKey = productStatuses?.inventory?.key?.toLowerCase()
    if (!productStatusKey) {
      productStatusKey = defaultSku?.[0]?.inventory?.toLowerCase()
    }
    const productStatusArray = [
      'outofstock',
      'discontinued',
      'unavailable',
      'preview',
    ]
    const disableAddToCartForLiveEvent =
      convertToBoolean(this.enableLiveEvent) &&
      shouldDisableLiveEventCartAction()

    const isAddToCartButtonEnabled = () => {
      const isBundleOrKit = product?.type == 'kit' || product?.type === 'bundle'
      const availableChannelsList = isBundleOrKit
        ? this.props.product?.properties?.availableChannels || ''
        : defaultSku?.[0]?.properties?.availableChannels || ''

      const isAddToCartButtonEnabled = checkEnableButton(
        availableChannelsList,
        getWebAvailableChannel()
      )

      this.isSubscriptionOnly =
        !isAddToCartButtonEnabled &&
        checkEnableButton(availableChannelsList, 'subscription')

      return isAddToCartButtonEnabled || this.isSubscriptionOnly
    }

    const disableAddBtn =
      productStatusArray?.includes(productStatusKey) ||
      disableAddToCartForLiveEvent ||
      false
    let skuPrices = []
    const skuList = product?.sku || []
    if (skuList && skuList.length) {
      skuPrices = skuList.filter(item => {
        return isVariantSelected
          ? this.selectedVariantValue?.selectedSku === item.identifier
          : item.default === true
      })
    }

    if (isFavorite) {
      CVPrice = CVPrice === 0 ? skuPrices?.[0]?.priceFacets?.CV || 0 : CVPrice
      PVPrice = PVPrice === 0 ? skuPrices?.[0]?.priceFacets?.PV || 0 : PVPrice
    }

    const transactionPrice =
      isFavorite &&
      skuPrices?.length &&
      skuPrices[0]?.prices &&
      skuPrices[0]?.prices?.length
        ? skuPrices[0].prices[0]
        : productOrSKUPrice && productOrSKUPrice?.length > 0
          ? productOrSKUPrice[0]
          : productOrSKUPrice
    const descriptionClass = application?.isMobile ? 'pl-2' : ''
    const mySiteRedesignPadding = this.props.isMySiteRedesign ? 'px-1' : 'px-0'
    const slug = this.props.product?.properties?.slug
    const skuId = defaultSku?.[0]?.identifier || ''
    const hasMoreThanOneSku = (this.props.product?.sku?.length || 1) > 1
    const productOrSlugId = slug ? slug : identifier
    const skuSlug = defaultSku?.[0]?.properties?.slug || ''
    const variantParameter = skuSlug || skuId || ''
    /* @variant_autoselect */
    const shouldAppendVariant = hasMoreThanOneSku && variantParameter
    let url = ''
    if (categoryId && shouldAppendVariant) {
      url = `${pageNames.product}/${productOrSlugId}?categoryId=${categoryId}&variant=${variantParameter}`
    } else if (categoryId) {
      url = `${pageNames.product}/${productOrSlugId}?categoryId=${categoryId}`
    } else if (shouldAppendVariant) {
      url = `${pageNames.product}/${productOrSlugId}?variant=${variantParameter}`
    } else {
      url = `${pageNames.product}/${productOrSlugId}`
    }

    const isLinkEnabled = isMerchPLP ? 'disabled' : ''
    const pathName =
      this.props?.location?.pathname ||
      (typeof window === 'object' && (window?.location?.pathname || ''))
    const isProductListPage =
      pathName.includes(pageNames.catalog) ||
      pathName.includes('template') ||
      pathName.includes(pageNames.search)

    const isFavouritePage = pathName.includes(pageNames.favorites)

    const showQuickView =
      enableQuickView &&
      (isProductListPage || isFavouritePage) &&
      specialProductTypes.indexOf(productType) === -1 &&
      !checkIsMobile()
    const productLevelPromotion = this.props?.product?.promotion || []
    const skuLevelPromotion =
      defaultSku && defaultSku.length ? defaultSku[0]?.promotion || [] : []
    const productAndSkuLevelPromotion = [
      ...skuLevelPromotion,
      ...productPromotion,
      ...productLevelPromotion,
    ]

    const isRange = this.checkIsRange(defaultSku?.[0]?.totalValue) || false
    const originalPrice = (totalValue && totalValue?.originalPrice) || 0
    const priceAfterDiscount =
      (totalValue && totalValue?.priceAfterDiscount) || 0

    const PVPriceOriginal =
      (this.isPlpRedesignEnabled || (isMySiteRedesign && isMySiteAdmin)) &&
      this.selectedVariantValue?.[this.selectedVariantValue?.selectedSku]
        ? this.selectedVariantValue?.[this.selectedVariantValue?.selectedSku]
            ?.totalValue?.priceFacets?.PV?.PV
        : defaultSku?.[0]?.totalValue?.priceFacets?.PV?.PV || PVPrice
    const PVPriceDiscount =
      this.isPlpRedesignEnabled &&
      this.selectedVariantValue?.[this.selectedVariantValue?.selectedSku]
        ? this.selectedVariantValue?.[this.selectedVariantValue?.selectedSku]
            ?.totalValue?.priceFacets?.PV?.PV
        : defaultSku?.[0]?.totalValue?.priceFacets?.PV?.PVAfterDiscount || 0

    const priceFreeValue = originalPrice - totalValue?.totaldiscount || 0
    const priceFreePromotion =
      priceAfterDiscount == 0 && priceFreeValue == 0 ? true : false

    const colorList = this.props?.colorList || []
    const userRole = customerContainer?.profileResponse?.userrole || ''
    const isSpecialProduct = specialProductTypes.includes(product?.type)
    const isAddtoCartPLPEnabled = convertToBoolean(
      APPConfig?.getAppConfig()?.enableAddToCartInPLP
    )
    const isToShowPVCVSV = isEligibleToShowPVCVSV({ accountType: localvalue })
    let categoryNameFlag = false
    const replacementProductStatus =
      this.props?.product?.sku?.[0]?.properties?.productStatus
        ?.toLowerCase?.()
        .trim() === 'discontinued'

    const isPbomProduct = productDeps.isPbomProduct(this.props?.product)
    const addLocale = i18nTranslate('bundle.add', 'Add', {
      nameSpace: 'ssr-resource',
    })
    const CartLocale = i18nTranslate('bundle.Cart', 'to Cart', {
      nameSpace: 'ssr-resource',
    })
    const isSeparateAddToCartEnabled = convertToBoolean(
      APPConfig?.getAppConfig()?.enableSearchAddToCart
    )
    const cartIconCheck =
      !isSeparateAddToCartEnabled || shouldRedirectBasedOnProduct(product)
    const tooltipText = cartIconCheck
      ? i18nTranslate('product.selectProducts', 'Select', {
          nameSpace: 'ssr-resource',
        })
      : i18nTranslate('pdp.addToCart', 'Add To Cart', {
          nameSpace: 'ssr-resource',
        })

    const IconComponent = cartIconCheck ? NuskinTaskIcon : NuskinPlusCartIcon
    const {
      isMySiteRedesign = false,
      isCheckboxDisabled = false,
      isStatusBasedDisabled = false,
      onSelectionChange = function () {},
      svPrice,
      maxSelectedProducts,
      isMySiteAdminPage = false,
    } = this.props || {}
    const isMySiteAdmin = IS_BROWSER
      ? window.location.pathname?.includes(pageNames.mysiteAdmin) ||
        window.location.pathname?.includes(pageNames.productOfferAdmin)
      : false
    const isOnPOAdminScreen = isPOAdminScreen()

    // Combine both conditions for checkbox visual state
    const isCheckboxVisuallyDisabled =
      (isOnPOAdminScreen && isVariantSelected && hasMoreThanOneSku
        ? this.state.isSelectedVariantDisabled
        : isStatusBasedDisabled) || isCheckboxDisabled
    const productOptions =
      !isBundle && this.props?.product?.sku?.length > 1
        ? builder.getUniqueProductOptions(this.props?.product?.sku)
        : []
    const variantLabel = productOptions?.filter(
      optionsAray => optionsAray?.type === 'variantLabel'
    )
    const variantTypeValues = variantLabel?.[0]?.values || []
    const defaultVariantLabel =
      defaultSku && defaultSku?.length
        ? defaultSku?.[0]?.properties?.variantLabel || ''
        : ''
    let carouselImages =
      this.isPlpRedesignEnabled && !isMerchPLP
        ? extractCarouselImages(product, imageURL, 5)
        : []

    if (
      this.isPlpRedesignEnabled &&
      !isMerchPLP &&
      carouselImages.length <= 1 &&
      defaultSku &&
      defaultSku[0]?.properties?.productImages
    ) {
      carouselImages = extractCarouselImages(
        {
          properties: { productImages: defaultSku[0].properties.productImages },
        },
        imageURL,
        5
      )
    }
    if (isEquinoxMysite()) {
      const selectedImageUrl = getSelectedImageUrlForMysitePLP(
        selectedCategories,
        product
      )
      if (selectedImageUrl) {
        const existingIndex = carouselImages.indexOf(selectedImageUrl)
        if (existingIndex > 0) {
          carouselImages.splice(existingIndex, 1)
          carouselImages.unshift(selectedImageUrl)
        } else if (existingIndex === -1) {
          carouselImages.unshift(selectedImageUrl)
        }
      }
    }

    const isDesktop = (this.state.windowWidth || 0) >= 768
    const showCarousel =
      this.isPlpRedesignEnabled &&
      !isMerchPLP &&
      !isEquinoxMysite() &&
      isDesktop &&
      carouselImages.length > 1
    const renderNavigationIcon = () => {
      return (
        <Link
          role="button"
          aria-label={`${addLocale} ${name} ${CartLocale}`}
          tabIndex={0}
          className="nav-in-card plp-cart-container d-flex justify-content-center align-items-center"
          to={url}
          data-testid="qa-product-name">
          <OverlayTrigger
            placement={'bottom'}
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip>{tooltipText}</Tooltip>}>
            <span>
              <IconComponent />
            </span>
          </OverlayTrigger>
        </Link>
      )
    }

    const renderCartIcon = () => {
      return (
        <div
          role="button"
          aria-label={`${addLocale} ${name} ${CartLocale}`}
          tabIndex={0}
          className="cart-in-card plp-cart-container d-flex justify-content-center align-items-center"
          onClick={e => {
            this.handleProductCart({
              event: e,
              imageRef: `product_card_img_${identifier}`,
              replacementProductStatus,
              url,
              product,
            })
            e.currentTarget.focus()
          }}
          onKeyPress={e => {
            this.handleProductCart({
              event: e,
              imageRef: `product_card_img_${identifier}`,
              replacementProductStatus,
              url,
              product,
            })
            e.currentTarget.focus() // Set focus on key press
          }}
          onMouseEnter={e => {
            e.currentTarget.focus() // Set focus on hover
          }}>
          <OverlayTrigger
            placement={'bottom'}
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip>{tooltipText}</Tooltip>}>
            <span>
              <IconComponent />
            </span>
          </OverlayTrigger>
        </div>
      )
    }
    const renderIcon = () => {
      if (!cartIconCheck) {
        return renderCartIcon()
      } else {
        return renderNavigationIcon()
      }
    }

    const buildProductToSend = newCheckedState => {
      let productToSend = product
      if (isOnPOAdminScreen && this.selectedVariantValue?.selectedSku) {
        const selectedSku = catalogDeps.getSelectedSkuById(
          this.props.product,
          this.selectedVariantValue.selectedSku
        )
        productToSend = {
          ...this.props.product,
          selectedVariantSkuId: this.selectedVariantValue.selectedSku,
          selectedVariantLabel: this.selectedVariantValue.selectedVariant || '',
          selectedSkuData: selectedSku?.[0] || null,
        }
      }
      return productToSend
    }

    const buildSelectionContext = () =>
      isOnPOAdminScreen
        ? { defaultSkuId: this.props.defaultSkuId }
        : undefined

    const handleKitProductSelection = (
      effectiveIdentifier,
      newCheckedState,
      productToSend
    ) => {
      this.handleKitSelection().then(kitSubItems => {
        const updatedProduct = kitSubItems
          ? { ...productToSend, selectedKitSubItems: kitSubItems }
          : productToSend
        if (onSelectionChange) {
          onSelectionChange(
            effectiveIdentifier,
            newCheckedState,
            updatedProduct,
            buildSelectionContext()
          )
        }
      })
    }

    const handleKeyboardSelection = (
      e,
      isCheckboxDisabled,
      localIsSelected
    ) => {
      const isValidKey =
        e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'
      if (!isValidKey || isCheckboxDisabled) return

      this.setState(
        prevState => ({ localIsSelected: !prevState.localIsSelected }),
        () => {
          // Side effects after state update
          const newCheckedState = this.state.localIsSelected

          const effectiveIdentifier =
            isOnPOAdminScreen && this.selectedVariantValue?.selectedSku
              ? this.selectedVariantValue.selectedSku
              : identifier

          const productToSend = buildProductToSend(newCheckedState)

          if (isKit && isOnPOAdminScreen && newCheckedState) {
            handleKitProductSelection(
              effectiveIdentifier,
              newCheckedState,
              productToSend
            )
          } else if (onSelectionChange) {
            onSelectionChange(
              effectiveIdentifier,
              newCheckedState,
              productToSend,
              buildSelectionContext()
            )
          }
        }
      )
    }

    const getAddToCartButtonText = () => {
      return !application?.isMobile
        ? i18nTranslate('pdp.addToCart', 'Add To Cart', {
            nameSpace: 'ssr-resource',
          })
        : i18nTranslate('prysm.add', 'Add', {
            nameSpace: 'ssr-resource',
          })
    }

    const getSelectOptionLabel = () => {
      return i18nTranslate('category_page.selectOption', 'Select Options', {
        nameSpace: 'ssr-resource',
      })
    }

    const getAddToCartLabel = () => {
      return i18nTranslate('catalog.Add', 'Add To Cart', {
        nameSpace: 'ssr-resource',
      })
    }
    return (
      <Card
        className={`plp-card-item product_card_${identifier} card-wrap position-relative bg-white mb-0 border-0 w-100 ${isLinkEnabled} border ${isMySiteRedesign && (isMySiteAdmin || isOnPOAdminScreen) ? 'mysite-productcard-checkbox' : ''}`}
        data-testid="qa-product-container"
        key={`product_card_${identifier}`}
        ref={element => (this.productCard = element)}
        onMouseLeave={this.closeDropdownOnMouseLeave}
        {...(isLinkEnabled === 'disabled' && {
          onClickCapture: e => {
            if (
              !e.target.classList.contains('allow-merchplp') &&
              !e.target.classList.contains('select-options-btn') &&
              !e.target.closest('.select-options-container')
            ) {
              e.stopPropagation()
            }
          },
        })}
        {...(onSelectionChange &&
          isMySiteRedesign &&
          isMySiteAdmin &&
          !isBundle && {
            onClick: e => {
              // Exclude all interactive elements from triggering checkbox
              if (
                e.target.classList.contains('select-options-btn') ||
                e.target.closest('.select-options-container') ||
                e.target.closest('.pdp-select-option') ||
                e.target.closest('.pdp-select-option-dropdown') ||
                e.target.closest('.dropdown') ||
                e.target.closest('.dropdown-toggle') ||
                e.target.closest('.dropdown-menu') ||
                e.target.closest('.manual-checkbox') ||
                e.target.closest('button') ||
                e.target.closest('a')
              ) {
                return
              }

              if (isStatusBasedDisabled) {
                return
              }

              e.preventDefault()
              e.stopPropagation()

              if (isCheckboxDisabled) {
                if (isMySiteAdminPage) {
                  return
                }
                toastState.setToastMessage(
                  i18nTranslate(
                    'mysitepo.maxProductSelectionThresholdReached',
                    'Maximum {count} products can be selected. Please remove a product to add a new one.'
                  ).replace('{count}', maxSelectedProducts),
                  false
                )
                return
              }
              // Update local state using callback to reference previous state
              this.setState(
                prevState => ({ localIsSelected: !prevState.localIsSelected }),
                () => {
                  // Side effects after state update
                  const newCheckedState = this.state.localIsSelected

                  // Use selected variant SKU if available (POAdmin only), otherwise use default identifier
                  const effectiveIdentifier =
                    isOnPOAdminScreen && this.selectedVariantValue?.selectedSku
                      ? this.selectedVariantValue.selectedSku
                      : identifier

                  // For POAdmin with selected variant, pass the full selected SKU data
                  let productWithVariant = product
                  if (
                    isOnPOAdminScreen &&
                    this.selectedVariantValue?.selectedSku
                  ) {
                    const selectedSku = catalogDeps.getSelectedSkuById(
                      this.props.product,
                      this.selectedVariantValue.selectedSku
                    )
                    productWithVariant = {
                      ...this.props.product, // Use original product with all SKUs
                      selectedVariantSkuId:
                        this.selectedVariantValue.selectedSku,
                      selectedVariantLabel:
                        this.selectedVariantValue.selectedVariant || '',
                      selectedSkuData: selectedSku?.[0] || null,
                    }
                  }

                  // For kit products in POAdmin, fetch and append kit subItems
                  if (isKit && isOnPOAdminScreen && newCheckedState) {
                    this.handleKitSelection().then(kitSubItems => {
                      if (kitSubItems) {
                        productWithVariant = {
                          ...productWithVariant,
                          selectedKitSubItems: kitSubItems,
                        }
                      }
                      // Notify parent
                      if (onSelectionChange) {
                        onSelectionChange(
                          effectiveIdentifier,
                          newCheckedState,
                          productWithVariant,
                          buildSelectionContext()
                        )
                      } else {
                        console.error('onSelectionChange not defined')
                      }
                    })
                  } else if (onSelectionChange) {
                    // Notify parent
                    onSelectionChange(
                      effectiveIdentifier,
                      newCheckedState,
                      productWithVariant,
                      buildSelectionContext()
                    )
                  } else {
                    console.error('onSelectionChange not defined')
                  }
                }
              )
            },
          })}>
        {onSelectionChange &&
          isMySiteRedesign &&
          isMySiteAdmin &&
          (isBundle && isOnPOAdminScreen
            ? this.state.localIsSelected
            : true) && (
            <div className="mysite-checkbox-container">
              <div className="form-check">
                <div
                  className={`manual-checkbox ${this.state.localIsSelected ? 'checked' : ''} ${isCheckboxVisuallyDisabled ? 'disabled' : ''}`}
                  data-testid={`qa-product-checkbox-${identifier}`}
                  tabIndex={isCheckboxVisuallyDisabled ? -1 : 0}
                  aria-label={name}
                  role="checkbox"
                  aria-checked={this.state.localIsSelected}
                  aria-disabled={isCheckboxVisuallyDisabled}
                  onKeyDown={e => {
                    handleKeyboardSelection(
                      e,
                      isCheckboxVisuallyDisabled,
                      this.state.localIsSelected
                    )
                  }}
                  onClick={e => {
                    e.stopPropagation()
                    if (isCheckboxVisuallyDisabled) {
                      return
                    }

                    // Update local state using callback to reference previous state
                    this.setState(
                      prevState => ({
                        localIsSelected: !prevState.localIsSelected,
                      }),
                      () => {
                        // Side effects after state update
                        const newCheckedState = this.state.localIsSelected

                        // Use selected variant for POAdmin
                        const effectiveIdentifier =
                          isOnPOAdminScreen &&
                          this.selectedVariantValue?.selectedSku
                            ? this.selectedVariantValue.selectedSku
                            : identifier

                        let productToSend = product
                        if (
                          isOnPOAdminScreen &&
                          this.selectedVariantValue?.selectedSku
                        ) {
                          const selectedSku = catalogDeps.getSelectedSkuById(
                            this.props.product,
                            this.selectedVariantValue.selectedSku
                          )
                          productToSend = {
                            ...this.props.product,
                            selectedVariantSkuId:
                              this.selectedVariantValue.selectedSku,
                            selectedVariantLabel:
                              this.selectedVariantValue.selectedVariant || '',
                            selectedSkuData: selectedSku?.[0] || null,
                          }
                        }

                        // For kit products in POAdmin, fetch and append kit subItems
                        if (isKit && isOnPOAdminScreen && newCheckedState) {
                          this.handleKitSelection().then(kitSubItems => {
                            if (kitSubItems) {
                              productToSend = {
                                ...productToSend,
                                selectedKitSubItems: kitSubItems,
                              }
                            }
                            // Notify parent (for data tracking, pub/sub)
                            if (onSelectionChange) {
                              onSelectionChange(
                                effectiveIdentifier,
                                newCheckedState,
                                productToSend,
                                buildSelectionContext()
                              )
                            }
                          })
                        } else if (onSelectionChange) {
                          // Notify parent (for data tracking, pub/sub)
                          onSelectionChange(
                            effectiveIdentifier,
                            newCheckedState,
                            productToSend,
                            buildSelectionContext()
                          )
                        }
                      }
                    )
                  }}>
                  {this.state.localIsSelected && (
                    <IoMdCheckmark className="checkbox-icon" />
                  )}
                </div>
              </div>
            </div>
          )}

        {isMySiteRedesign && isMySiteAdmin ? (
          <div
            className="image-container-wrap"
            aria-label={name}
            id={`product_card_img_${identifier}`}
            ref={this.currentRef}
            tabIndex={0}
            style={{ cursor: 'default' }}>
            <ProductBadge
              productBadge={productBadge}
              badgeRendertype={template6 ? 'horizontal' : 'diagonal'}
            />

            {showCarousel ? (
              <ProductImageCarousel
                images={
                  isMySiteAdmin && isMySiteRedesign
                    ? carouselImages?.filter?.(url => {
                        if (!url || typeof url !== 'string') return false
                        const lowerUrl = url?.toLowerCase()
                        const videoFormats = [
                          '.mp4',
                          '.mov',
                          '.webm',
                          '.avi',
                          '.wmv',
                          '.flv',
                          '.mkv',
                          '.m4v',
                          '.3gp',
                          '.ogg',
                        ]
                        return !videoFormats?.some?.(format =>
                          lowerUrl?.endsWith?.(format)
                        )
                      })
                    : carouselImages
                }
                alt={name}
                testId="qa-plp-product-image"
                loadingType={isFromCatalog && index < 8 ? 'eager' : 'lazy'}
              />
            ) : (
              <ImageComponent
                testId="qa-plp-product-image"
                className={`plp-product-image`}
                src={imageURL}
                alt={name}
                plpImprovementClass={true}
                optimizeImage={true}
                loadingType={isFromCatalog && index < 8 ? 'eager' : 'lazy'}
              />
            )}
          </div>
        ) : (
          <Link
            to={url}
            className="image-container-wrap"
            aria-label={name}
            id={`product_card_img_${identifier}`}
            ref={this.currentRef}
            tabIndex={0}
            onClick={this.handleProductClick}>
            <ProductBadge
              productBadge={productBadge}
              badgeRendertype={template6 ? 'horizontal' : 'diagonal'}
            />

            {showCarousel ? (
              <ProductImageCarousel
                images={carouselImages}
                alt={name}
                testId="qa-plp-product-image"
                loadingType={isFromCatalog && index < 8 ? 'eager' : 'lazy'}
              />
            ) : (
              <ImageComponent
                testId="qa-plp-product-image"
                className={`plp-product-image`}
                src={imageURL}
                alt={name}
                plpImprovementClass={true}
                optimizeImage={true}
                loadingType={isFromCatalog && index < 8 ? 'eager' : 'lazy'}
              />
            )}
          </Link>
        )}
        {/* {(showQuickView || isPbomProduct) && (
          <button
            onClick={e =>
              this.handleQuickView(
                e,
                `product_card_img_${identifier}`,
                replacementProductStatus
              )
            }
            onKeyPress={e =>
              this.handleQuickView(
                e,
                `product_card_img_${identifier}`,
                replacementProductStatus
              )
            }
            tabIndex="0"
            className="text-uppercase quickview-label position-absolute m-auto py-1 px-3"
            data-testid="qa-quick-view-button">
            {i18nTranslate('plp.quickView', 'quick view', {
              nameSpace: this.nameSpace,
            })}
          </button>
        )} */}
        {getFavoritesEnabled() && !(isMySiteAdmin && isMySiteRedesign) && (
          <ProductFavorites
            {...{ productId: productId || identifier, name, categoryId }}
          />
        )}
        <Card.Body
          className={`product-description flex-direction-column pt-0 pb-2 mt-3 ${descriptionClass} ${mySiteRedesignPadding}`}
          data-testid="qa-figcaption">
          {enableProductCompare &&
            isProductListPage &&
            isProductComparable &&
            this.renderProductCompare()}
          {Array.isArray(colorList) &&
            colorList.length > 0 &&
            colorList.map(colorObj => {
              const color = colorObj?.color
              return (
                <Button
                  key={color}
                  variant=""
                  aria-label={color}
                  className={`${
                    this.props?.product?.selectedSku?.identifier ===
                    colorObj?.skuId
                      ? 'border-primary'
                      : 'border-none'
                  } mr-0 mb-2 p-1 text-uppercase`}
                  onClick={() =>
                    this.props.changeSku(colorObj?.skuId, identifier)
                  }>
                  <div
                    className="border"
                    style={{
                      background: colorCode[color],
                      height: '25px',
                      width: '25px',
                    }}
                  />
                </Button>
              )
            })}
          <div className="mt-3">{renderPrysmBadgeContent(product)}</div>
          <div className="text-decoration-none">
            {categoryNameFlag && (
              <Card.Title
                className="brand-name flex-nowrap font-weight-medium text-dark overflow-hidden w-100"
                data-testid="qa-product-brand">
                {brand}
              </Card.Title>
            )}
            <div className="d-flex position-relative plp-name-container">
              {isMySiteAdmin && isMySiteRedesign ? (
                <span
                  className="catalog-product-name flex-nowrap font-weight-bold h-auto paragraph-m"
                  data-testid="qa-product-name"
                  tabIndex={0}
                  aria-label={name}>
                  {name}
                </span>
              ) : (
                <Link
                  to={url}
                  aria-label={name}
                  onClick={this.handleProductClick}
                  className="catalog-product-name flex-nowrap h-auto paragraph-m"
                  data-testid="qa-product-name">
                  {name}
                </Link>
              )}
              {!this.isPlpRedesignEnabled &&
                !this.props.hideAddToCart &&
                renderIcon()}
            </div>
            {this.isPlpRedesignEnabled && (
              <p
                className={`plp-product-description mt-1 mb-2 ${
                  isMySiteAdmin && isMySiteRedesign ? 'd-none' : ''
                }`}>
                {product?.properties?.description?.trim() ||
                  defaultSku?.[0]?.properties?.description?.trim() ||
                  ''}
              </p>
            )}
          </div>
          <div
            className={`${!(isMySiteRedesign && isMySiteAdmin) ? 'plp-hide-on-hover' : ''}`}>
            <ProductStatusBadge
              product={this.props?.product}
              size="small"
              selectedPlpSku={defaultSku}
            />
          </div>
          {enableDirectSellerButton && (
            <Button
              type="button"
              aria-lable={i18nTranslate('direct-seller-pdp', 'Direct Seller')}
              variant="contained"
              className="direct-seller-plp-in-button"
              data-testid="qa-direct-seller-pdp">
              {i18nTranslate('direct-seller-pdp', 'Direct Seller')}
            </Button>
          )}

          {!isRange && (
            <>
              <Row
                noGutters
                className="product-price flex-row"
                data-testid="qa-product-price"
                tabIndex={0}>
                <ProductCardPrice
                  priceLable={
                    isMySiteRedesign && isMySiteAdmin
                      ? false
                      : (this.props?.isToShowPriceLabel ?? true)
                  }
                  {...this.props}
                  selectedPlpSku={
                    this.selectedVariantValue?.[
                      this.selectedVariantValue?.selectedSku
                    ] || {}
                  }
                  bundlePriceOverride={this.bundlePromotionResponse?.totalValue || {}}
                />
              </Row>
              {isToShowPVCVSV && userRole?.length > 0 && (
                <>
                  <Row
                    noGutters
                    className="product-ProductPrice pv-price"
                    data-testid="qa-product-price"
                    tabIndex={
                      this.isPlpRedesignEnabled
                        ? PVPriceOriginal
                        : PVPrice
                          ? 0
                          : -1
                    }>
                    <CustomPrice
                      custompriceValue={
                        this.isPlpRedesignEnabled ? PVPriceOriginal : PVPrice
                      }
                      custompriceLabel={i18nTranslate('pdp.svprice', 'SV', {
                        nameSpace: this.nameSpace,
                      })}
                      {...this.props}
                      dataTestId="qa-pdp-pvprice"
                      isPVCV={true}
                    />
                  </Row>
                </>
              )}
            </>
          )}
          {isRange && (
            <>
              <Row
                noGutters
                className="product-price"
                data-testid="qa-product-price"
                tabIndex={0}>
                <ProductCardPrice
                  priceLable={
                    isMySiteRedesign && isMySiteAdmin
                      ? false
                      : (this.props?.isToShowPriceLabel ?? true)
                  }
                  {...this.props}
                  selectedPlpSku={
                    this.selectedVariantValue?.[
                      this.selectedVariantValue?.selectedSku
                    ] || {}
                  }
                  bundlePriceOverride={this.bundlePromotionResponse?.totalValue || {}}
                />
              </Row>
              {isToShowPVCVSV && userRole?.length > 0 && (
                <>
                  <Row
                    noGutters
                    className="product-price pv-price"
                    data-testid="qa-product-price"
                    tabIndex={0}>
                    <CustomPrice
                      custompriceValue={PVPriceOriginal}
                      customDiscountPriceValue={PVPriceDiscount}
                      custompriceLabel={i18nTranslate('pdp.svprice', 'SV', {
                        nameSpace: this.nameSpace,
                      })}
                      {...this.props}
                      dataTestId="qa-pdp-pvprice"
                      isPVCV={true}
                    />
                  </Row>
                </>
              )}
            </>
          )}
          {!(isMySiteRedesign || isMySiteAdmin) && (
            <ProductPromotion
              promotion={productAndSkuLevelPromotion}
              isProductCard={true}
              isToShowPromoOnImage={true}
            />
          )}
          {(this.isPlpRedesignEnabled &&
            !(isMySiteRedesign && isMySiteAdmin)) ||
          (isOnPOAdminScreen && isMySiteRedesign) ? (
            <div className="hover-add-btn-container">
              {!isBundle ? (
                <>
                  <div className="pdp-select-box-container">
                    {this.renderSelectOptions(
                      variantTypeValues,
                      skuId,
                      defaultVariantLabel
                    )}
                  </div>
                  {!(isOnPOAdminScreen && isMySiteRedesign) && (
                    <Button
                      className="onhover-add-btn d-flex cta align-items-center mt-2 justify-content-center"
                      aria-label={getAddToCartButtonText()}
                      onClick={
                        disableAddBtn || this.disableNormalMultiVariantAddBtn
                          ? () => {}
                          : this.handleAddClick
                      }
                      disabled={
                        disableAddBtn ||
                        this.disableNormalMultiVariantAddBtn ||
                        !isAddToCartButtonEnabled()
                      }
                      data-testid="qa-plp-add-button">
                      {getAddToCartButtonText()}
                    </Button>
                  )}
                </>
              ) : (
                <Button
                  className="onhover-add-btn d-flex cta align-items-center mt-2 justify-content-center"
                  aria-lable={getSelectOptionLabel()}
                  onClick={() => this.handleSelectOptionsClick(identifier)}
                  onKeyPress={() => this.handleSelectOptionsClick(identifier)}
                  disabled={isOnPOAdminScreen && this.isFetchingOptions}
                  data-testid="qa-plp-select-button">
                  {getSelectOptionLabel()}
                </Button>
              )}
            </div>
          ) : (
            isAddtoCartPLPEnabled &&
            this.props.isFromCatalog &&
            !isSpecialProduct && (
              <Button
                className="pop-add-btn d-flex cta text-uppercase w-100 align-items-center mt-2 justify-content-center"
                aria-label={getAddToCartLabel()}
                onKeyPress={e => {
                  this.handleAddClick(e)
                }}
                onClick={e => {
                  this.handleAddClick(e)
                }}>
                <CartIconNew style={{ fontSize: '24px', marginRight: '4px' }} />
                {getAddToCartLabel()}
              </Button>
            )
          )}
          {isBundle && this.isPlpRedesignEnabled && (
            <PlpBundleOrKitSelectOptions
              productResponse={this.bundlePdpResponse}
              handleCancelSelectOptionsClick={
                this.handleCancelSelectOptionsClick
              }
              isAddToCartButtonEnabled={
                !disableAddBtn && isAddToCartButtonEnabled()
              }
              isSubscriptionOnly={this.isSubscriptionOnly}
              isFromCatalog={this.props.isFromCatalog || false}
              isPOAdminScreen={isOnPOAdminScreen}
              onBundleSelect={this.handleBundleSelection}
              triggerBundlePromotionCall={this.makePromotionCallForBundleProducts}
              product={product}
              previouslySelectedBundleVariants={
                this.props.selectedBundleVariants
              }
            />
          )}
        </Card.Body>
        <MerchAlternateImages
          imageArrayProperties={this.imageArrayProperties}
          handleCurrentImage={this.handleCurrentImage}
        />
        {isBundle && isOnPOAdminScreen && this.isFetchingOptions && (
          <div className="plp-fetching-options-overlay">
            <NsSpinner size={40} />
          </div>
        )}
      </Card>
    )
  }
}

ProductCard.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  itemListName: PropTypes.string,
  categoryName: PropTypes.string,
  productIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  position: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export { ProductCard }
export default ProductCard
